<template>
  <iMineTemplate :pageTitle="pageTitle" :activedParentKey="activedParentKey" :activedKey="activedKey">
    <template #rightContent>
      <div class="address">
        <div class="title" style="position:relative;">
          <span>收货地址</span>
          <div style="float:right;" v-if="false">
            <van-button @click="showDig" type="info" plain class="btn">编辑</van-button>
          </div>
        </div>
        <div class="content">
          <van-row v-for="Address in AddressInfo" v-bind:key="Address.Name" type="flex">
            <van-col span="3">
              <span class="name">{{Address.Name}}</span>
            </van-col>
            <van-col span="16">
              <div class="info">{{Address.Content}}</div>
            </van-col>
          </van-row>
        </div>
        <div class="note">
          <van-icon :name="`${iconnote}`" size="18" />
          <span>声明：为严格执行《药品管理法》及《药品经营质量管理规范》的相关规定，送货地址默认为《药品经营许可证》中的经营地址或仓库请联系客服：{{lang.Basic.ServicePhone}}</span>
        </div>
        <van-dialog style="height:540px;border-radius: 2px;" v-model="show" width="755" :showConfirmButton="false">
          <component v-bind="{AddressInfo:AddressObject}" v-on:EditClose="closeEdit" :is="activedUrl"></component>
        </van-dialog>
      </div>
    </template>
  </iMineTemplate>
</template>

<script>
  export default {
    name: "AddressShow",
    data() {
      return {
        pageTitle: ["我的账户", "收货地址"],
        activedParentKey: 1,
        activedKey: 14,
        activedUrl: "AddressEdit",
        iconnote: require("@/assets/mine/note.png"),
        show: false,
        AddressObject: null,
        AddressObjectOld: null,
        AddressInfo: [
          { Name: "联系人", Content: "" },
          { Name: "联系方式", Content: "" },
          { Name: "收货地址", Content: "" }
        ],
        urls: {
          getCustomer: "/api_customers/Customer/CustomerContactDetail",
          getReceivingAddress: "/api_customers/Customer/GetCustomerReceivingAddress"
        }
      };
    },
    mounted() {
      this.getCustomer();
    },
    methods: {
      //弹出编辑框
      showDig() {
        this.AddressObjectOld = this.list = JSON.parse(
          JSON.stringify(this.AddressObject)
        );
        this.show = true;
      },
      //关闭编辑框事件，响应编辑业中的emit消息EditClose,并获取要保存的数据,最后刷新页面
      closeEdit(res) {
        if (res == true) this.bindDataToPage(this.AddressObject);
        else this.AddressObject = this.AddressObjectOld;
        this.show = false;
      },
      //获取客户信息
      async getCustomer() {
        var that = this;
        that.$hys.openLoading();
        let res = await this.getAction(this.urls.getCustomer);
        that.$hys.clearLoading();
        if (!res.IsSuccess) {
          this.$toast({ position: "bottom", message: res.Msg });
          return;
        }
        let customerId = res.Data.CustomerId;
        that.getReceivingAddress(customerId);
      },
      //通过客户编号获取收货地址
      async getReceivingAddress(customerId) {
        var that = this;
        this.$hys.openLoading();
        let res = await this.postAction(this.urls.getReceivingAddress, [
          customerId
        ]);
        this.$hys.clearLoading();
        if (!res.IsSuccess) {
          this.$toast({ position: "bottom", message: res.Msg });
          return;
        }
        that.AddressObject = res.Data[0];
        this.bindDataToPage(that.AddressObject);
      },
      //将数据绑定至控件
      bindDataToPage(AddressObject) {
        this.AddressInfo[0].Content = AddressObject.ReceivingMan;
        this.AddressInfo[1].Content = AddressObject.Phone;
        this.AddressInfo[2].Content = AddressObject.AddressName + ' ' + AddressObject.Address;
      }
    }
  };
</script>
<style lang="less" scoped>
  .address {
    margin: 0 20px 20px 0;
    width: 940px;
    height: 411px;
    padding: 20px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(232, 232, 232, 1);
    // padding: 20px;
    position: relative;
    box-sizing: border-box;

    .title {
      width: 898px;
      height: 42px;
      border-bottom: 1px solid #e8e8e8;
      line-height: 22px;

      span {
        float: left;
        font-size: 18px;
        color: rgba(34, 34, 34, 1);
      }

      /deep/.btn {
        width: 68px;
        height: 30px;
        border-radius: 2px;
        border: 1px solid rgba(15, 110, 233, 1);

        /deep/.van-button__text {
          color: red;
          font-size: 14px;
          font-weight: 400;
          color: rgba(15, 110, 234, 1);
          line-height: 20px;
        }
      }
    }

    .content {
      text-align: left;
      width: 898px;
      padding: 20px;
      font-weight: 400;
      line-height: 32px;
      box-sizing: border-box;

      .name {
        color: rgba(119, 119, 119, 1);
      }

      .info {
        color: rgba(34, 34, 34, 1);
      }
    }

    .note {
      width: 900px;
      height: 76px;
      background: rgba(255, 246, 216, 1);
      border-radius: 2px;
      font-weight: 400;
      color: rgba(211, 105, 31, 1);
      line-height: 25px;
      margin-top: 30px;
      padding: 15px;
      text-align: left;
      box-sizing: border-box;

      /deep/.van-icon {
        font-size: 18px;
        position: relative;
        top: 4px;
        right: 3px;
      }
    }
  }
</style>